import { render } from "./add copy.vue?vue&type=template&id=db0cb948&scoped=true"
import script from "./add copy.vue?vue&type=script&lang=js"
export * from "./add copy.vue?vue&type=script&lang=js"

import "./add copy.vue?vue&type=style&index=0&id=db0cb948&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db0cb948"]])

export default __exports__